import { ReactNode } from 'react';
import { withStyles } from 'vopay';
import { CopyButton } from 'UI';
import styles from './CopyableValue.module.scss';

const cn = withStyles(styles);

type CopyableValueProps = {
  /** What the copy button puts on the clipboard. */
  value: string;
  /** What is shown; the raw value when omitted. */
  label?: ReactNode;
};

/**
 * A detail-row value with a copy-to-clipboard button beside it (spec 5.6.1: "Account ID (with
 * copy)"). What is shown and what is copied are separate, so a formatted label can sit over a raw
 * value; the label sits in its own element so a test can read it without the button's icon glyph.
 */
export default function CopyableValue({ value, label = value }: CopyableValueProps) {
  return (
    <span className={cn('copyableValue')}>
      <span>{label}</span>
      <CopyButton content={value} size="small" />
    </span>
  );
}
